import { withStyles } from '@material-ui/core';
import SignatureWidget from './SignatureWidget';
import styles from './SignatureWidget.styles';

export default withStyles(styles)(SignatureWidget);
